export const SHARE_AND_COLLABORATE_TOUR_ID = 'share-and-collaborate-tour-spotlight';
export const SHARE_AND_COLLABORATE_TOUR_STEP_1_SPOTLIGHT_ID =
	'share-and-collaborate-tour-step-1-spotlight';
